<template>
  <div>
    <main class="main">
      <div class="bredcumb">
        <div class="container">
          <ul>
            <li><router-link to="/index">首頁</router-link></li>
            <li>聯絡我們</li>
          </ul>
        </div>
      </div>

      <div class="bodyContent">
        <!-- <div class="section">
          <h2>聯絡我們</h2>
        </div> -->
        <div class="container">
          <section class="aboutJin">
            <h2>聯絡我們</h2>
            <div>
              <ul class="iconWithIntro">
                <li class="wow fadeInUp">
                  <div class="decoImg"><img src="@/assets/images/deco_jin_03.png" alt="" /></div>
                  <p>若您在使用「一刻鯨選」遇到問題，或課程內容上有什麼疑問，請讓我們為您服務。</p>
                  <p>聯絡信箱：<a href="mailto:jinfm.hi@gmail.com">jinfm.hi@gmail.com</a></p>
                </li>
              </ul>
            </div>
          </section>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
/* eslint-disable no-undef */
export default {
  name: 'async',
  metaInfo () {
    return {
      title: '聯絡我們 | 一刻鯨選',
      meta: [
        // OpenGraph data (Most widely used)
        { property: 'og:title', content: '聯絡我們 | 一刻鯨選' },
        { property: 'og:site_name', content: '聯絡我們 | 一刻鯨選' },
        // The list of types is available here: http://ogp.me/#types
        { property: 'og:type', content: 'website' },
        // Should the the same as your canonical link, see below.
        { property: 'og:url', content: window.location.toString() },
        // {property: 'og:image', content: '/static/logo.png'},
        // Often the same as your meta description, but not always.
        { property: 'og:description', content: '想進一步瞭解一刻鯨選，或是有任何寶貴意見，都歡迎您與我們聯繫！' }

      ]
    }
  },

  data () {
    return {
      classData: []
    }
  },
  methods: {

    changePage (page) {
      this.$router.push({ path: '/' + page })
    }

  },
  mounted () {
    $('body').removeClass('index')
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/views/Contact.vue